<template lang="html">
	<section class="block">
		<h3>{{ $t(`${sector}.${abast}.external.title`) }}</h3>
		<p v-if="isReportEditable" class="note">{{ $t(`${sector}.${abast}.external.desc`) }}</p>
		<emissions-table v-if="!skip" v-model="emissions" :editable="isReportEditable">
			<template v-slot:header>
				<th>{{ $t('report.table.concept') }}</th>
				<th>{{ $t('report.table.vehicle') }}</th>
				<th>{{ $t('report.table.motorization') }}</th>
				<th>
					<span :data-tooltip-alert="$t('tooltip.km_vs_hour')">
						<i class="mdi mdi-alert-circle icon icon--emphasis" />
					</span>
					{{ $t('report.table.distance') }}
				</th>
			</template>
			<template v-slot:body="{ item }">
				<td>{{ item.concept }}</td>
				<td>{{ item.vehicle.label }}</td>
				<td>{{ item.resource.label }}</td>
				<td>{{ item.qty }}<em class="unit">{{ item.resource.unit }}</em></td>
			</template>
			<template v-slot:insert="{ insert }">
				<td>
					<input
						type="text"
						class="long"
						v-model="insert.concept"
						:placeholder="$t(`${sector}.${abast}.external.example`)" />
				</td>
				<td>
					<dropdown-select
						:options="VEHICLES"
						v-model="insert.vehicle"
						:placeholder="$t('report.table.vehicle')" />
				</td>
				<td :data-tooltip="insert.vehicle ? false : $t('tooltip.require.vehicle')">
					<dropdown-select
						v-model="insert.resource"
						:disabled="isEmpty(insert.vehicle)"
						:options="isEmpty(insert.vehicle) ? [] : insert.vehicle.emissions.distance"
						:placeholder="$t('report.table.motorization')" />
				</td>
				<td :data-tooltip="isEmpty(insert.resource)
					? $t('tooltip.require.motorization')
					: $t('tooltip.unit_in', { unit: insert.resource.unit })">
					<input
						v-model.number="insert.qty"
						:disabled="isEmpty(insert.resource)"
						:placeholder="isEmpty(insert.resource)
							? $t('report.table.distance')
							: insert.resource.unit"
						type="number"
						min="0"
						step="0.1" />
				</td>
			</template>
		</emissions-table>
		<p v-if="isSkipperVisible">
			<label>
				<input type="checkbox" v-model="skip" :disabled="!isReportEditable" />
				{{ $t('global.tip.skip') }}
			</label>
		</p>
	</section>
</template>

<script>
import StepBlockMixin from '@/mixins/StepBlockMixin';
import EmissionsTable from '@/components/EmissionsTable.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import { isEmpty } from '@/utils';
import VEHICLES from '@/assets/constants/vehicles';

const isNotCollective = (vehicle) => !vehicle.collective;

export default {
	name: 'StepExternal',
  keyBlock: 'external',
	mixins: [StepBlockMixin],
	components: { EmissionsTable, DropdownSelect },
	data() {
		return { VEHICLES: VEHICLES.filter(isNotCollective) };
	},
	methods: { isEmpty },
};
</script>
